import React from 'react';


/**
 * The Footer component displays footer icons for navigation.
 */
function Footer() {
  return (
    <div className="footer-icon-container">
      <a href="https://whatthefsharp.com"><i className="footer-icon fa-solid fa-house"></i></a>
      <a href="mailto:eloise.rosen+WTFS@gmail.com"><i className="footer-icon fa-solid fa-envelope"></i></a>
      <a href="https://ELOISE-LIKES-MAKING-THINGS.com"><i className="footer-icon fa-solid fa-user"></i></a>
      <a href="https://www.buymeacoffee.com/eloiserosen"><i className="footer-icon fa-solid fa-mug-hot"></i></a>
    </div>
  );
}

export default Footer;
